import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Parser } from 'maf-web';
import { AppService } from '../app.service';
import { VitrineModelService } from '../service/vitrine.model.service';
import { ConsClienteAPP, DataParametrosAPP } from '../vo/sitevo.vo';
import { ConsVitrineAndItem } from '../vo/liquidacaoparcelaejb.vo';

@Component({
  selector: 'inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {

  nomeCliente: string = 'Cliente';
  listaVitrine: ConsVitrineAndItem[];
  isLoadVitrine: boolean = true;

  get parametrosAPP(): DataParametrosAPP { return this.app.parametrosAPP; }
  get consCliente(): ConsClienteAPP { return this.app.consCliente; }
  get isConsultaEstoqueControle(): boolean { return this.app.isConsultaEstoqueControle(); }

  constructor(
    private app: AppService,
    private vitrine: VitrineModelService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const listaNome = this.app.consCliente.nome.split(' ');
    this.nomeCliente = listaNome && listaNome.length > 0 ? listaNome[0] : this.app.consCliente.nome;
    // this.vitrine.getListVitrineAndItem()
    //   .then((data: ConsVitrineAndItem[]) => this.listaVitrine = data)
    //   .catch(error => console.error(error))
    //   .then(() => this.isLoadVitrine = false);
    this.isLoadVitrine = false;
  }

  formatarMoeda(valor: number): string {
    return Parser.formatarMoeda(valor);
  }

  getTelefoneFormatado(): string {
    return Parser.formataFone(this.app.parametrosAPP.telefone);
  }

  getLimiteCredito(): string {
    return (100 - ((this.consCliente.limiteCredito * 100) / this.consCliente.totalLimiteCredito)) + '%';
  }

  abrirVitrine(url: string) {
    const win = window.open(url, '_blank');
    win.focus();
  }

  validar() {
    this.app.modalConfirmacao = true;
  }

  compra() {
    this.router.navigate(['/compra']);
  }

  parcela() {
    this.router.navigate(['/parcela']);
  }

  lojas() {
    this.router.navigate(['/lojas']);
  }

  abrirConsultaEstoqueControle() {
    this.app.abrirConsultaEstoqueControle();
  }

}
